module.exports = __webpack_public_path__ + "img/cardLeftImg.52b06990.png";